import { ExternalLink } from "lucide-react";

export const SampleBadge = ({ label = "Sample data", testId = "sample-badge" }) => (
  <span className="pill pill-amber" data-testid={testId}>{label}</span>
);

export const TwiFlag = () => (
  <span className="pill pill-blue" data-testid="twi-validation-flag">Needs Twi speaker validation</span>
);

export const SourceTag = ({ source, url, testId }) =>
  url ? (
    <a href={url} target="_blank" rel="noreferrer" data-testid={testId || "source-link"} className="inline-flex items-center gap-1 font-data text-[10px] uppercase tracking-wider text-slate-400 hover:text-[color:var(--gold)] transition-colors">
      Source: {source} <ExternalLink size={10} />
    </a>
  ) : (
    <span className="font-data text-[10px] uppercase tracking-wider text-slate-500">Source: {source}</span>
  );

const SENT = { positive: "pill-green", neutral: "pill-slate", negative: "pill-red" };
export const SentimentBadge = ({ value }) =>
  value ? <span className={`pill ${SENT[value] || "pill-slate"}`} data-testid="sentiment-badge">{value}</span> : <span className="pill pill-slate">analysing…</span>;

const STATUS = {
  available: ["#38A169", "Available"], on_air: ["#E53E3E", "On air"], on_assignment: ["#DD6B20", "On assignment"],
  on_leave: ["#805AD5", "On leave"], off_duty: ["#4A5568", "Off duty"],
};
export const StatusDot = ({ status }) => {
  const [c, l] = STATUS[status] || ["#4A5568", status];
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-slate-300" data-testid={`status-${status}`}>
      <span className="w-2 h-2 rounded-full" style={{ background: c }} /> {l}
    </span>
  );
};

export const Decision = ({ children }) => (
  <p className="mt-4 pt-3 border-t border-[color:var(--line)] text-[11px] text-slate-400"><span className="text-gold font-data uppercase tracking-wider mr-2">Decision enabled</span>{children}</p>
);

export const SectionHead = ({ eyebrow, title, children }) => (
  <div className="mb-8 max-w-3xl">
    <div className="eyebrow mb-3">{eyebrow}</div>
    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-ink">{title}</h2>
    {children && <p className="mt-3 text-sm md:text-base text-slate-400 leading-relaxed">{children}</p>}
  </div>
);
